import React from 'react';
import { Stack, Typography } from '@mui/material';
import AutoDeleteOutlinedIcon from '@mui/icons-material/AutoDeleteOutlined';

// Dezenter Retention-Hinweis fuer Upload- und Listen-Seite.
// days ist konfigurierbar, Default 365.
export default function RetentionNotice({ days = 365, sx }) {
  return (
    <Stack
      direction="row"
      spacing={0.75}
      alignItems="center"
      justifyContent="center"
      sx={sx}
    >
      <AutoDeleteOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
      <Typography variant="caption" color="text.secondary">
        Transkripte und zugehörige Dateien werden nach {days} Tagen automatisch
        gelöscht.
      </Typography>
    </Stack>
  );
}
